<template>
  <div class="dialog-preview">
    <div class="body" v-if="form" ref="body">
      <div class="close" @click="$emit('close')"></div>

      <div class="container">
        <ChoiceEcho ref="ChoiceEcho" v-if="form.type == 0" :form="form"></ChoiceEcho>
        <DetermineEcho ref="DetermineEcho" v-else-if="form.type == 1" :form="form"></DetermineEcho>
        <FillingBlanksEcho ref="FillingBlanksEcho" v-else-if="form.type == 2" :form="form"></FillingBlanksEcho>
        <SumEcho ref="SumEcho" v-else-if="form.type == 3 || form.type == 8" :form="form"></SumEcho>
        <HotspotEcho ref="HotspotEcho" v-else-if="form.type == 4" :form="form"></HotspotEcho>
        <TextDragEcho ref="TextDragEcho" v-else-if="form.type == 5" :form="form"></TextDragEcho>
        <LigatureEcho ref="LigatureEcho" v-else-if="form.type == 6" :form="form"></LigatureEcho>
        <ImgDragEcho ref="ImgDragEcho" v-else-if="form.type == 7" :form="form"></ImgDragEcho>
        <TextDragEcho2 ref="TextDragEcho2" v-else-if="form.type == 9" :form="form"></TextDragEcho2>
        <MatrimFill ref="MatrimFill" v-else-if="form.type == 10" :form="form"></MatrimFill>
      </div>
    </div>
  </div>
</template>

<script>
import ChoiceEcho from './components/choice/choice_echo.vue';
import DetermineEcho from './components/determine/determine_echo.vue';
import FillingBlanksEcho from './components/fillingBlanks/fillingBlanks_echo.vue';
import MatrimFill from './components/fillingBlanks/matrim_fill.vue';
import SumEcho from './components/sum/sum_echo.vue'
import ImgDragEcho from './components/imgDrag/imgDrag_echo.vue'
import TextDragEcho from './components/textDrag/textDrag_echo.vue'
import TextDragEcho2 from './components/textDrag/textDrag_echo_2.vue'
import LigatureEcho from './components/ligature/ligature_echo.vue'
import HotspotEcho from './components/hotspot/hotspot_echo.vue'

export default {
  props: {
    form: {
      type: Object
    }
  },
  components: {
    ChoiceEcho,
    DetermineEcho,
    FillingBlanksEcho,
    MatrimFill,
    SumEcho,
    ImgDragEcho,
    TextDragEcho,
    TextDragEcho2,
    LigatureEcho,
    HotspotEcho,
  },
  data() {
    return {
    }
  },

  mounted() {
    // 对于大多数现代浏览器
    // document.body.addEventListener('wheel', function(e) {
    //     e.preventDefault();
    // }, { passive: false });
  }
}
</script>

<style lang="scss" scoped>
.dialog-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #9b9b9b;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  font-family: "TaipeiSansTCBeta";
  .body {
    height: 80%;
    width: 90%;
    background-color: #fff6ec;
    border-radius: 15px;
    padding: 25px;
    box-sizing: border-box;
    position: relative;
    .close {
      position: absolute;
      top: -60px;
      right: -60px;
      width: 60px;
      height: 60px;
      cursor: pointer;
      border-radius: 50%;
      background-image: url('../../../assets/images/close.png');
      background-size: 100% 100%;
    }

    .container {
      width: 100%;
      height: 100%;
      overflow: auto;
      position: relative;
      font-family: 'TimesNewRoman', sans-serif;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss">

.dialog-preview {
  .block-style-success {
    &:before {
      content: '';
      border: 2px solid #007416 !important;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../../assets/images/circle-success.png');
      background-size: 100% 100%;
    }
  }

  .hotspot .block-style-success {
    &:before {
      content: '';
      border: 2px dashed #007416 !important;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../../assets/images/circle-success.png');
      background-size: 100% 100%;
    }
  }

  .determine-success-br {
    border: 2px solid #007416 !important;
    position: relative !important;

    &:before {
      content: '';
      position: absolute;
      bottom: -6px;
      right: -6px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../../assets/images/circle-success.png');
      background-size: 100% 100%;
    }
  }
}

</style>